import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import ChartConfig, { tooltipStyle } from 'Constants/chart-config';

import {  
  mskVisualisationDetails
} from 'Actions';

class spineChartComponent extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };
   
  constructor(props) {
    super(props);
  }

  render() {

    const { visualisationdetails, loading} = this.props;
    let spinelist= visualisationdetails.spine; 
    
    const data=spinelist.map((assmntval) => {  
          return {              
              name: assmntval.assessment,
              trunkflex: assmntval.trunkflex,
              trunkext: assmntval.trunkext,
              sideright: assmntval.trunksideright,
              sideleft: assmntval.trunksideleft
          }
    }); 
    return (
      
      <ResponsiveContainer width={this.props.data} height={400}>         
        <BarChart data={data}>
          <XAxis dataKey="name" stroke={ChartConfig.axesColor} />
          <YAxis stroke={ChartConfig.axesColor} domain={[0, 'dataMax + 5']} />
          <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
          <Tooltip wrapperStyle={tooltipStyle} cursor={false} />
          <Legend />
          <Bar dataKey="trunkflex" name="Trunk Forward Flexion" fill={ChartConfig.color.leftshER} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="trunkext" name="Trunk Extension" fill={ChartConfig.color.rightshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="sideright" name="Trunk Side Flexion Right" fill={ChartConfig.color.leftshIR} label={{ position: "top" }} barSize={20}/>
          <Bar dataKey="sideleft" name="Trunk Side Flexion Left"  fill={ChartConfig.color.rightshER} label={{ position: "top" }} barSize={20}/>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails
})(spineChartComponent); 